function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { AverageStarRatingAndTotal } from '@domain-group/fe-co-allhomes-average-star-rating-and-total';
import { Card } from './components/card';
import { Footer } from './components/footer';
import * as styles from './allhomes-agent-recommendations.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgentRecommendations = _ref => {
  var reviews = _ref.reviews,
    url = _ref.url,
    heading = _ref.heading,
    brandingLevel = _ref.brandingLevel,
    overallRating = _ref.overallRating,
    reviewCount = _ref.reviewCount;
  var INITIAL_DISPLAYED_REVIEWS = 5;
  var ADDITIONAL_REVIEWS = 10;
  var maxDisplayedReviews = INITIAL_DISPLAYED_REVIEWS + ADDITIONAL_REVIEWS;
  var hasReviews = reviews.length > 0;
  var isGold = ['PLATINUM', 'GOLD'].includes(brandingLevel);
  var _useState = useState(Math.min(reviews.length, INITIAL_DISPLAYED_REVIEWS)),
    _useState2 = _slicedToArray(_useState, 2),
    displayedReviews = _useState2[0],
    setDisplayedReviews = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpanded = _useState4[0],
    setIsExpanded = _useState4[1];
  useEffect(() => {
    setDisplayedReviews(Math.min(reviews.length, isExpanded ? maxDisplayedReviews : INITIAL_DISPLAYED_REVIEWS));
  }, [isExpanded, maxDisplayedReviews, reviews.length]);
  var toggleReviews = () => {
    setIsExpanded(prev => !prev);
  };
  return hasReviews ? ___EmotionJSX("section", {
    css: styles.container
  }, ___EmotionJSX("div", {
    css: styles.header
  }, ___EmotionJSX("div", {
    css: styles.heading
  }, heading), ___EmotionJSX("div", {
    css: styles.headingMobile
  }, "Reviews"), isGold && reviewCount > 0 && ___EmotionJSX(Fragment, null, ___EmotionJSX("div", {
    css: styles.headerDivider
  }), ___EmotionJSX(AverageStarRatingAndTotal, {
    averageRating: overallRating,
    totalReviews: reviewCount
  }))), reviews.slice(0, displayedReviews).map(review => ___EmotionJSX(Card, _extends({
    key: "".concat(review.title).concat(review.date)
  }, review))), ___EmotionJSX(Footer, {
    displayedReviews: displayedReviews
    // Cater for scenario where reviews exist but review info does not
    // such as in case of old, but existent, DB reviews
    ,
    totalReviews: Math.max(reviewCount, reviews.length),
    url: url,
    isExpanded: isExpanded,
    onButtonClick: toggleReviews
  })) : null;
};
AllhomesAgentRecommendations.propTypes = {
  reviews: PropTypes.arrayOf(PropTypes.shape({})),
  url: PropTypes.string,
  heading: PropTypes.string,
  brandingLevel: PropTypes.oneOf(['GOLD', 'PLATINUM', 'CASUAL']),
  overallRating: PropTypes.number,
  reviewCount: PropTypes.number
};
AllhomesAgentRecommendations.defaultProps = {
  reviews: [],
  url: '',
  heading: 'Reviews',
  brandingLevel: 'CASUAL',
  overallRating: 0,
  reviewCount: 0
};
export { AllhomesAgentRecommendations };